import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getDocumentlainContent = createAsyncThunk('/documentlain/content', async (nopage) => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listCompanyOtherFile/${userId}?page=${nopage}`, {})
    return response.data;
})

export const documentlainSlice = createSlice({
    name: 'documentlain',
    initialState: {
        isLoading: false,
        documentlain : []
    },
    reducers: {


        addNewDocumentlain: (state, action) => {
            let {newDocumentlainObj} = action.payload
            state.documentlain = [...state.documentlain, newDocumentlainObj]
        },

        deleteDocumentlain: (state, action) => {
            let {index} = action.payload
            state.documentlain.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getDocumentlainContent.pending]: state => {
			state.isLoading = true
		},
        [getDocumentlainContent.fulfilled]: (state, action) => {
            state.documentlain = action.payload.data
			state.isLoading = false
		},
        [getDocumentlainContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getDocumentlainContent.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getDocumentlainContent.fulfilled, (state, action) => {
            state.documentlain = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getDocumentlainContent.rejected, (state) => {
            state.isLoading = false;
          });
      }
})

export const { addNewDocumentlain, deleteDocumentlain } = documentlainSlice.actions

export default documentlainSlice.reducer